import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'Components/Icon';
import { classnames } from 'Utils/classnames';
import EnvironmentManager from 'Utils/environmentManager';
import { useSelector } from 'react-redux';

const SportTypesMenu = subHeader => {
  const menuContainer = useRef(null);
  const [showLeftIcon, setShowLeftIcon] = useState(false);
  const [showRightIcon, setShowRightIcon] = useState(true);
  const { topWinEnabled } = useSelector(state => state.auth.data);
  const zirveOranSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_switch' }) === 'true';

  const renderSubHeader = subHeader?.data
    ?.filter(item => (zirveOranSwitch && topWinEnabled) || item?.type !== 160)
    ?.map((subHeaderItem, index) => (
      <Link
        to={ subHeaderItem.webDeepLink && subHeaderItem.webDeepLink.replace('bulten/uv-', 'iddaa/uzun-vadeli-') }
        key={ index }
        title={ subHeaderItem.sportTypeName }
        className={ classnames({
          'sub-header-item': true,
        }) }
      >
        <img src={ subHeaderItem.imageUrl } />
        <div>{ subHeaderItem.sportTypeName }</div>
        <div
          className={ classnames({
            isLive: subHeaderItem.isLive,
          }) }
        >
          { subHeaderItem.count }
        </div>
      </Link>
    ));

  const handleNav = direction => {
    let newScrollValue;
    if (direction === 'left') {
      newScrollValue = menuContainer.current.scrollLeft - 200;
    } else {
      newScrollValue = menuContainer.current.scrollLeft + 200;
    }

    menuContainer.current.scrollLeft = newScrollValue;

    setShowLeftIcon(newScrollValue > 0);

    if (
      menuContainer.current.scrollLeft
      >= menuContainer.current.scrollWidth - menuContainer.current.clientWidth
    )
      setShowRightIcon(false);
    else setShowRightIcon(true);
  };

  return (
    <>
      <div className="sub-header-div">
        { subHeader.data?.length > 8 && showLeftIcon && (
          <Icon className='sub-header-container__sportTypeLeftIcon' iconName='svgChevronRight' onClick = { () => handleNav('left') } />
        ) }
        <div className="sub-header-container" ref={ menuContainer }>
          { renderSubHeader }
        </div>
        { subHeader?.data?.length > 8 && showRightIcon && (
          <Icon className='sub-header-container__sportTypeRightIcon' iconName='svgChevronRight' onClick = { () => handleNav('right') } />
        ) }
      </div>
    </>
  );
};

export default SportTypesMenu;
